import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { Card } from 'design-system/src/components/Card/Card';
import { CardContent, CardSection } from './styles';
import { PageContainerWithLogo } from './PageContainerWithLogo.tsx';
import { ReturnToHomePageButton } from './ReturnToHomePageButton';

export type PatientFallbackProps = {
  className?: string;
};

export const PatientFallback = ({ className }: PatientFallbackProps) => {
  return (
    <PageContainerWithLogo className={className}>
      <Card>
        <CardContent>
          <Typography styledAs="h6">Our Tandem portal for patients is coming soon</Typography>
          <CardSection>
            <Typography>In the meantime, Tandem will text you with updates about your prescriptions.</Typography>
            <Typography>
              Need help? Send us an email at{' '}
              <Button variant="link" href="mailto:support@withtandem.com" textStyledAs="bodyDMSans">
                support@withtandem.com
              </Button>
              {'. '}
            </Typography>
          </CardSection>
          <ReturnToHomePageButton linkType="patient" />
        </CardContent>
      </Card>
    </PageContainerWithLogo>
  );
};

export default PatientFallback;
